import * as Sentry from "@sentry/react";

/**
 * 浏览器 DOM 竞态（如 rc-select / Ant Design 与 React 更新不同步）触发的 removeChild 报错，
 * 不应触发整页容错 UI，但仍可在边界内上报监控。
 */
export function isBenignDomError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : String(error);
  return msg.includes("removeChild");
}

export function setupGlobalErrorHandler() {
  window.addEventListener("unhandledrejection", (event) => {
    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason));
    Sentry.captureException(error, {
      tags: { globalHandler: "unhandledrejection" },
    });
  });

  window.addEventListener("error", (event) => {
    const error = event.error ?? new Error(event.message);
    Sentry.captureException(error, {
      tags: { globalHandler: "window.error" },
    });
  });
}
